import React from "react";
import { Menu, message } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";
import isEmpty from "lodash/isEmpty";
import startsWith from "lodash/startsWith";
import WeaCollect from "../wea-collect";
import WeaInput from "../wea-input";
import WeaDialog from "../wea-dialog";
import WeaTools from "../wea-tools";
import WeaLocaleProvider from "../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

const Item = Menu.Item;

class RightMenu extends React.Component {
  static displayName = "RightMenu";
  static defaultProps = {
    datas: [],
    collectParams: undefined,
    helpParams: {}
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.state = {
      collectVisable: false,
      urlVisible: false,
      showUrlItem: false
    };
  }
  componentDidMount() {
    WeaTools.callApi("/api/ec/dev/app/getUserInfo", "GET").then(res => {
      this.setState({ showUrlItem: res.isAdmin });
    });
    this.instanceIsMounted = true;
  }
  componentWillUnmount() {
    this.instanceIsMounted = false;
  }
  getMenu = datas => (
    <Menu
      mode="vertical"
      onClick={o => {
        if (o.key === "collect") {
          this.setState({ collectVisable: true });
        } else if (o.key === "showURL") {
          this.setState({ urlVisible: true });
        } else {
          const { onClick } = this.props;
          if (o.key !== "showHelp" && o.key !== "copy" && o.key !== "paste")
            typeof onClick === "function" && onClick(o.key);
          datas.forEach(
            d =>
              d.key === o.key &&
              typeof d.onClick === "function" &&
              d.onClick(o.key)
          );
        }
      }}
    >
      {datas.map((d, i) => {
        return (
          <Item key={d.key || i} disabled={d.disabled}>
            <li unselectable="on" className="wea-right-menu-item">
              <span unselectable="on" className="wea-right-menu-icon">
                {d.icon}
              </span>
              <span unselectable="on" title={d.title || d.content}>
                {d.content}
              </span>
            </li>
          </Item>
        );
      })}
    </Menu>
  );
  getCollect = () => (
    <WeaCollect
      {...this.props.collectParams}
      visible={this.state.collectVisable}
      onClose={() => this.setState({ collectVisable: false })}
    />
  );
  getUrl = () => (
    <WeaDialog
      style={{ top: 20 }}
      className="wea-right-menu-url-dialog"
      icon="icon-coms-PageAddress"
      iconBgcolor="#fa0"
      title={getLabel("385958", "来自$s").replace(/\$s/, window.location.host)}
      visible={this.state.urlVisible}
      style={{ width: 580 }}
      maskClosable={true}
      onCancel={() => this.setState({ urlVisible: false })}
    >
      <div className="wea-right-menu-url">
        <WeaInput
          ref="inputUrl"
          value={window.location.href}
          onChange={() =>
            this.refs.inputUrl.refs.inputNormal.setState({
              value: window.location.href
            })
          }
        />
        <CopyToClipboard
          ref={c => (this.copyUrl = c)}
          text={window.location.href}
          onCopy={() => message.success(getLabel("385957", "复制URL成功"))}
        >
          <i className="icon-coms-copy" title={getLabel("127566", "复制URL")} />
        </CopyToClipboard>
      </div>
    </WeaDialog>
  );
  render() {
    const {
      datas: _datas,
      collectParams,
      inDialog = false,
      helpParams
    } = this.props;
    const { showUrlItem } = this.state;
    // localStorage.setItem(showCopyAndPaste, { showCopyAndPaste: 1 })
    const showHelp = WeaTools.ls.getJSONObj("showHelp") || { showHelp: "" };
    // const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    // const isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
    // let isIE =
    //   userAgent.indexOf("compatible") > -1 &&
    //   userAgent.indexOf("MSIE") > -1 &&
    //   !isOpera;
    let showCopyAndPaste = {
      showCopyAndPaste: ""
    };
    let isIE = false;
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      isIE = true;
    }
    // const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    // reIE.test(userAgent);
    // const fIEVersion = parseFloat(RegExp["$1"]);
    // if (fIEVersion == 7) {
    //   isIE = true;
    // } else if (fIEVersion == 8) {
    //   isIE = true;
    // } else if (fIEVersion == 9) {
    //   isIE = true;
    // } else if (fIEVersion == 10) {
    //   isIE = true;
    // } else if (fIEVersion == 11) {
    //   isIE = true;
    // }
    if (isIE) {
      showCopyAndPaste = WeaTools.ls.getJSONObj("showCopyAndPaste") || {
        showCopyAndPaste: ""
      };
    }
    const other = [];
    collectParams &&
      other.push({
        key: "collect",
        icon: <i className="icon-coms-Collection" />,
        content: getLabel("28111", "收藏")
      });
    showCopyAndPaste.showCopyAndPaste === "1" &&
      other.push(
        {
          key: "copy",
          icon: <i className="icon-coms-copy" />,
          content: getLabel("77", "复制"),
          onClick: () => {
            document.execCommand("copy");
          }
        },
        {
          key: "paste",
          icon: <i className="icon-coms-Paste" />,
          content: getLabel("16180", "粘贴"),
          onClick: () => {
            if (window.clipboardData) {
              const text = window.clipboardData.getData("Text");
              const dom = document.querySelector("input:focus,textarea:focus");
              if (dom) {
                const start = dom.selectionStart;
                const end = dom.selectionEnd;
                const domText = dom.value;
                dom.value =
                  domText.substring(0, start) + text + domText.substring(end);
                if (dom.className === "ant-select-search__field") {
                  // 浏览按钮
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发浏览按钮中input点击事件
                }
                if (dom.parentNode.parentNode.className === "wea-input-focus") {
                  // wea-input-search
                  dom.pasteValue =
                    domText.substring(0, start) + text + domText.substring(end);
                  dom.click(); // 手动触发浏览按钮中input点击事件
                }
              }
            } else {
              alert(
                "您的浏览器安全设置不允许编辑器自动执行粘贴操作，请使用键盘快捷键（ Ctrl+V）来完成。"
              );
              return false;
            }
          }
        }
      );
    (showHelp.showHelp === "true" ||
      (helpParams.helpDocid && helpParams.helpDocid !== "")) &&
      other.push({
        key: "showHelp",
        icon: <i className="icon-coms-help" />,
        content: getLabel(275, "帮助"),
        onClick: () => {
          let url = window.location.hash,
            tabKeys = window.tabKeys || [],
            urlParamsIndex = 0;
          url = url.replace("#/", "");
          url = url.replace("main/", "");
          url = url.slice(0, url.indexOf("?")); //去掉_key
          if (startsWith(url, "portal")) {
            inDialog ? (url = "portal/menu") : (url = "portal/summary");
          }
          Array.isArray(tabKeys) &&
            !isEmpty(tabKeys) &&
            tabKeys.forEach((v, l) => {
              const key = v.slice(v.indexOf("_key:") + 5, v.indexOf("_name:")),
                name = v.slice(v.indexOf("_name:") + 6);
              if (name !== "") {
                url += urlParamsIndex === 0 ? "?" : "&";
                // url += `key${urlParamsIndex}=${key},name${urlParamsIndex}=${name}`;
                url += `key${urlParamsIndex}=${key}`;
                urlParamsIndex++;
              }
            });
          const Base64 = ecCom.WeaTools.Base64;
          let src =
            "https://www.e-cology.com.cn/formmode/apps/ktree/ktreeHelpE9.jsp?pathKey=" +
            Base64.encode(url);
          !isEmpty(Object.keys(helpParams)) &&
            (src = "/spa/document/index.jsp?id=" + helpParams.helpDocid);
          const userLanguage = window.e9_locale
            ? window.e9_locale.userLanguage
            : 7;
          window.open(src + "&lang=" + userLanguage);
        }
      });
    showUrlItem &&
      other.push({
        key: "showURL",
        icon: <i className="icon-coms-PageAddress" />,
        content: getLabel("21682", "显示页面地址")
      });

    const datas = _datas.concat(other);
    if (typeof this.props.customMenu === "function") {
      this.props.customMenu(datas);
    }
    this.isEmpty = datas.length === 0;
    if (datas.length === 0) return null;
    const list = [
      <iframe className="wea-right-menu-iframe" />,
      <div className="wea-right-menu-icon-background" />,
      this.getMenu(datas)
    ];
    collectParams && list.push(this.getCollect());
    showUrlItem && list.push(this.getUrl());
    return list;
  }
}

export default RightMenu;



// WEBPACK FOOTER //
// ./ecology9/wea-right-menu/RightMenu.js